import { LabelPrintData } from "src/apis/labelApi";
import { formatDate } from "src/utils/string/stringUtil";

import {
	KSK2140_R01HeaderDto,
	KSK2140_R01LotDto,
} from "./Dto_KSK2140_R01";

const formatQty = (qty: number | undefined, unit: string): string => {
	if (!qty && qty !== 0) return "";
	return `${qty.toLocaleString()}${unit || "EA"}`;
};

/** 제품검사 저장 시 발행된 LOT 목록을 라벨 출력 데이터로 변환한다. */
export const KSK2140_R01_buildLabelDataList = (
	lotList: KSK2140_R01LotDto[],
	header: KSK2140_R01HeaderDto,
): LabelPrintData[] =>
	lotList
		.filter((lot) => Boolean(lot.lotNo?.trim()))
		.map((lot) => ({
			lotNo: lot.lotNo,
			itemCd: lot.itemCd || header.itemCd || "",
			itemNm: lot.itemNm || header.itemNm || "",
			itemSpec: lot.itemSpec || header.itemSpec || "",
			transportDate: header.productDt
				? formatDate(new Date(header.productDt))
				: formatDate(new Date()),
			itemAccountNm: "",
			storageLocation:
				lot.warehouseNm
				|| lot.warehouseCd
				|| header.warehouseNm
				|| header.warehouseCd
				|| "-",
			qty: formatQty(lot.lotQty, lot.itemUnit || header.itemUnit || "EA"),
			customer: header.compNm || "",
			customerItemCd: "",
			labelType: "생산입고",
		}));
